import { extractLanguageCode } from '../../common/LocaleUtils/LocaleUtils';
export const dataHooks = {
    icon: 'date-input-date-icon',
};
const shortDateFormats = {
    en: 'MM/dd/yyyy',
    'en-US': 'MM/dd/yyyy',
    'en-GB': 'dd/MM/yyyy',
    'en-AU': 'dd/MM/yyyy',
    'en-CA': 'yyyy-MM-dd',
    ar: 'dd/MM/yyyy',
    bg: 'dd/MM/yyyy',
    ca: 'dd/MM/y',
    zh: 'MM/dd/yyyy',
    'zh-TW': 'yy-MM-dd',
    'zh-HK': 'yy-MM-dd',
    'zh-MO': 'MM/dd/yyyy',
    cs: 'dd.MM.yyyy',
    da: 'dd/MM/y',
    nl: 'dd-MM-y',
    fi: 'd.M.y',
    fr: 'dd/MM/y',
    'fr-CA': 'yy-MM-dd',
    'fr-CH': 'dd.MM.y',
    'fr-BE': 'MM/dd/yyyy',
    de: 'dd.MM.y',
    'de-CH': 'MM/dd/yyyy',
    'de-AT': 'dd.MM.y',
    el: 'd/M/yy',
    he: 'd.M.y',
    hi: 'dd/MM/yyyy',
    hu: 'y. MM. dd.',
    id: 'd/M/yyyy',
    it: 'dd/MM/y',
    ja: 'y/MM/dd',
    ko: 'y.MM.dd',
    lt: 'y-MM-dd',
    ms: 'd/M/yyyy',
    no: 'MM/dd/yyyy',
    nb: 'dd.MM.y',
    nn: 'dd.MM.y',
    pl: 'dd.MM.y',
    'pt-BR': 'dd/MM/yyyy',
    pt: 'dd/MM/y',
    ro: 'dd.MM.yyyy',
    ru: 'dd.MM.y',
    sk: 'd. M. y',
    sl: 'd. MM. yy',
    es: 'dd/MM/y',
    'es-419': 'MM/dd/yyyy',
    'es-AR': 'MM/dd/yyyy',
    'es-MX': 'MM/dd/yyyy',
    'es-US': 'MM/dd/yyyy',
    sv: 'y-MM-dd',
    tl: 'MM/dd/yyyy',
    th: 'dd/MM/yyyy',
    tr: 'dd.MM.yyyy',
    uk: 'dd.MM.y',
    vi: 'dd/MM/y',
};
export const getShortDateFormat = (locale) => {
    return (shortDateFormats[locale] ?? shortDateFormats[extractLanguageCode(locale)]);
};
const mediumDateFormats = {
    en: 'MMM d, y',
    'en-US': 'MMM d, y',
    'en-GB': 'd MMM yyyy',
    'en-AU': 'd MMM yyyy',
    'en-CA': 'MMM d, yyyy',
    ar: 'd MMM y',
    bg: 'dd MMM yyyy',
    ca: 'd MMM y',
    zh: 'MMM d, y',
    'zh-TW': 'yyyy-MM-dd',
    'zh-HK': 'yyyy-MM-dd',
    'zh-MO': 'MMM d, y',
    cs: 'd. M. yyyy',
    da: 'd. MMM y',
    nl: 'd MMM y',
    fi: 'd. MMM y',
    fr: 'd MMM y',
    'fr-CA': 'd MMM y',
    'fr-CH': 'd MMM y',
    'fr-BE': 'MMM d, y',
    de: 'do MMM y',
    'de-CH': 'MMM d, y',
    'de-AT': 'do MMM y',
    el: 'd MMM y',
    he: 'd בMMM y',
    hi: 'd MMM, y',
    hu: 'y. MMM d.',
    id: 'd MMM yyyy',
    it: 'd MMM y',
    ja: 'y/MM/dd',
    ko: 'y.MM.dd',
    lt: 'y-MM-dd',
    ms: 'd MMM yyyy',
    no: 'MMM d, y',
    nb: 'd. MMM y',
    nn: 'd. MMM y',
    pl: 'do MMM y',
    'pt-BR': 'd MMM y',
    pt: "d 'de' MMM 'de' y",
    ro: 'd MMM yyyy',
    ru: "d MMM y 'г.'",
    sk: 'd. M. y',
    sl: 'd. MMM y',
    es: 'd MMM y',
    'es-419': 'MMM d, y',
    'es-AR': 'MMM d, y',
    'es-MX': 'MMM d, y',
    'es-US': 'MMM d, y',
    sv: 'd MMM y',
    tl: 'MMM d, y',
    th: 'd MMM y',
    tr: 'd MMM y',
    uk: "d MMM y 'р.'",
    vi: "d MMM 'năm' y",
};
export const getMediumDateFormat = (locale) => {
    return (mediumDateFormats[locale] ?? mediumDateFormats[extractLanguageCode(locale)]);
};
const longDateFormats = {
    en: 'MMMM do, y',
    'en-US': 'MMMM do, y',
    'en-GB': 'MMMM do, y',
    'en-AU': 'MMMM do, y',
    'en-CA': 'MMMM do, y',
    ar: 'do MMMM y',
    bg: 'dd MMMM yyyy',
    ca: "d 'de' MMMM y",
    zh: 'MMMM do, y',
    'zh-TW': 'MMMM do, y',
    'zh-HK': 'MMMM do, y',
    'zh-MO': 'MMMM do, y',
    cs: 'd. MMMM yyyy',
    da: 'd. MMMM y',
    nl: 'd MMMM y',
    fi: 'd. MMMM y',
    fr: 'd MMMM y',
    'fr-CA': 'd MMMM y',
    'fr-CH': 'd MMMM y',
    'fr-BE': 'd MMMM y',
    de: 'do MMMM y',
    'de-CH': 'do MMMM y',
    'de-AT': 'do MMMM y',
    el: 'd MMMM y',
    he: 'd בMMMM y',
    hi: 'do MMMM, y',
    hu: 'y. MMMM d.',
    id: 'd MMMM yyyy',
    it: 'd MMMM y',
    ja: 'y年M月d日',
    ko: 'y년 M월 d일',
    lt: "y 'm'. MMMM d 'd'.",
    ms: 'd MMMM yyyy',
    no: 'MMMM do, y',
    nb: 'd. MMMM y',
    nn: 'd. MMMM y',
    pl: 'do MMMM y',
    'pt-BR': "d 'de' MMMM 'de' y",
    pt: "d 'de' MMMM 'de' y",
    ro: 'd MMMM yyyy',
    ru: "d MMMM y 'г.'",
    sk: 'd. MMMM y',
    sl: 'dd. MMMM y',
    es: "d 'de' MMMM 'de' y",
    'es-419': "d 'de' MMMM 'de' y",
    'es-AR': "d 'de' MMMM 'de' y",
    'es-MX': "d 'de' MMMM 'de' y",
    'es-US': "d 'de' MMMM 'de' y",
    sv: 'd MMMM y',
    tl: 'MMMM do, y',
    th: 'do MMMM y',
    tr: 'd MMMM y',
    uk: "do MMMM y 'р.'",
    vi: "'ngày' d MMMM 'năm' y",
};
export const getLongDateFormat = (locale) => {
    return (longDateFormats[locale] ?? longDateFormats[extractLanguageCode(locale)]);
};
const fullDateFormats = {
    en: 'EEEE, MMMM do, y',
    'en-US': 'EEEE, MMMM do, y',
    'en-GB': 'EEEE, MMMM do, y',
    'en-AU': 'EEEE, MMMM do, y',
    'en-CA': 'EEEE, MMMM do, y',
    ar: 'EEEE، do MMMM y',
    bg: 'EEEE, dd MMMM yyyy',
    ca: "EEEE, d 'de' MMMM y",
    zh: 'EEEE, MMMM do, y',
    'zh-TW': 'EEEE, MMMM do, y',
    'zh-HK': 'EEEE, MMMM do, y',
    'zh-MO': 'EEEE, MMMM do, y',
    cs: 'EEEE, d. MMMM yyyy',
    da: "EEEE 'den' d. MMMM y",
    nl: 'EEEE d MMMM y',
    fi: 'eeee d. MMMM y',
    fr: 'EEEE d MMMM y',
    'fr-CA': 'EEEE d MMMM y',
    'fr-CH': 'EEEE d MMMM y',
    'fr-BE': 'EEEE d MMMM y',
    de: 'EEEE, do MMMM y',
    'de-CH': 'EEEE, do MMMM y',
    'de-AT': 'EEEE, do MMMM y',
    el: 'EEEE, d MMMM y',
    he: 'EEEE, d בMMMM y',
    hi: 'EEEE, do MMMM, y',
    hu: 'y. MMMM d., EEEE',
    id: 'EEEE, d MMMM yyyy',
    it: 'EEEE d MMMM y',
    ja: 'y年M月d日EEEE',
    ko: 'y년 M월 d일 EEEE',
    lt: "y 'm'. MMMM d 'd'., EEEE",
    ms: 'EEEE, d MMMM yyyy',
    no: 'EEEE, MMMM do, y',
    nb: 'EEEE d. MMMM y',
    nn: 'EEEE d. MMMM y',
    pl: 'EEEE, do MMMM y',
    'pt-BR': "EEEE, d 'de' MMMM 'de' y",
    pt: "EEEE, d 'de' MMMM 'de' y",
    ro: 'EEEE, d MMMM yyyy',
    ru: "EEEE, d MMMM y 'г.'",
    sk: 'EEEE d. MMMM y',
    sl: 'EEEE, dd. MMMM y',
    es: "EEEE, d 'de' MMMM 'de' y",
    'es-419': "EEEE, d 'de' MMMM 'de' y",
    'es-AR': "EEEE, d 'de' MMMM 'de' y",
    'es-MX': "EEEE, d 'de' MMMM 'de' y",
    'es-US': "EEEE, d 'de' MMMM 'de' y",
    sv: 'EEEE d MMMM y',
    tl: 'EEEE, MMMM do, y',
    th: 'วันEEEEที่ do MMMM y',
    tr: 'd MMMM y EEEE',
    uk: "EEEE, do MMMM y 'р.'",
    vi: "EEEE, 'ngày' d MMMM 'năm' y",
};
export const getFullDateFormat = (locale) => {
    return (fullDateFormats[locale] ?? fullDateFormats[extractLanguageCode(locale)]);
};
//# sourceMappingURL=constants.js.map